module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_BlackMatted_MockedUp.14958ff2.jpg";